import { render, staticRenderFns } from "./PaisListAddNew.vue?vue&type=template&id=67abbc66&"
import script from "./PaisListAddNew.vue?vue&type=script&lang=js&"
export * from "./PaisListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PaisListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports